import "./TextAreaEdit.scss"
import { Form } from "antd";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useTranslation } from "react-i18next";

const TextAreaEdit = ({ component, hasTitle=true, lang, handleChangeText }) => {
    const { t } = useTranslation("translations", "forms")

    const handleChangeTextArea = (value, delta, source) => {
        if (source === "user") {
            handleChangeText(value)
        }
    }

    return (
        <div className="form-manager-textarea-edit">
            <Form.Item label={hasTitle && t("forms.manager.section.text.title", {ns: "forms"})}>
                <ReactQuill key={lang} defaultValue={component.text && component.text[lang]} 
                    onChange={handleChangeTextArea} 
                />
            </Form.Item>
        </div>
    )
}

export default TextAreaEdit;